import ITisPossibleAnswerData from './tis-possible-answer-data';

export const TisPossibleAnswerDefault: ITisPossibleAnswerData = {
    id: null,
    tempId: '',
    answer: ''
};
